import type { FunctionComponent } from "react"

import { useComputeAlgoliaJobAdsRequest } from "@/modules/jobAds/client/hooks/useComputeAlgoliaJobAdsRequest"

import { AlgoliaRequestParamsRetrieverButtons } from "./AlgoliaRequestParamsRetrieverButtons"

export const AlgoliaRequestParamsRetriever: FunctionComponent = () => {
  const algoliaJobAdsRequest = useComputeAlgoliaJobAdsRequest()

  return <AlgoliaRequestParamsRetrieverButtons algoliaJobAdsRequest={algoliaJobAdsRequest} />
}
